import type { JSX } from 'react'

export const ForwardIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use href='#forwardIcon' height='100%' width='100%' />
    <use
      href='#forwardSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
